import React from "react";
import { FiFilter, FiPlus } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";

const UnassignedHeader = ({ onToggleFilter, permission }) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const M_id = queryParams.get("id");

    return (
        <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
            {permission?.pf_add === 1 && (
                <div className="btn btn-icon btn-light-brand" onClick={onToggleFilter}>
                    <FiFilter />
                </div>
            )}
        </div>
    );
};

export default UnassignedHeader;
